/**
 * Reducer for obtaining flight routes
 */
import Constants from '../constants/RelationshipTypesConstants';
import { List as IList } from 'immutable';

const initialState = IList();

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function relationshipTypes (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.RELATIONSHIP_TYPES_REQUEST:
      return IList();

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.RELATIONSHIP_TYPES_SUCCESS:
      return IList(action.data);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.RELATIONSHIP_TYPES_FAILURE:
      return IList();

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/RelationshipTypesReducer.js